import * as React from 'react';
import { ArticleFragmentContext } from '../contexts';
import useArticles from '../hooks/useArticles';
const isGroupFunction = (arg) => {
    return typeof arg === 'function';
};
function returnChild(children, data) {
    return (React.createElement(React.Fragment, null, React.isValidElement(children)
        ? children
        : isGroupFunction(children)
            ? children(data)
            : null));
}
/**
 * Provides a way to access the categories data via a render prop.
 *
 * Utilises [[useArticles]] under the hood.
 */
export const Group = ({ children, categoryId }) => {
    const articlesData = useArticles(categoryId);
    return React.createElement(React.Fragment, null, returnChild(children, articlesData));
};
Group.displayName = 'Articles.Group';
const isArticleLoopFunction = (arg) => {
    return typeof arg === 'function';
};
/** Checks the type of the react child and returns in the correct way */
export function returnLoopChild(children, data) {
    return React.isValidElement(children)
        ? children
        : isArticleLoopFunction(children)
            ? children(data)
            : null;
}
/**
 * For each of the articles of the either the current category in context or the `categoryId` passed in, it repeats the children passed in.
 *
 * - If you pass a render prop as a child it will be called with each sub category result.
 * - Else if you pass in React Elements they will be repeated for each sub category result.
 *
 * Usage example:
 * ```javascript
 * export const LoopedArticles = () => {
 *   return (
 *     <Articles.Loop>
 *       <div className="mb-6 block">
 *         <Article.Link className="mb-2" data-testid="article-link">
 *           <Article.Title />
 *         </Article.Link>
 *         <Article.Summary className="text-grey-light text-sm" />
 *       </div>
 *     </Articles.Loop>
 *   );
 * };
 * ```
 */
export const Loop = ({ children }) => {
    const { articles } = useArticles();
    if (!articles)
        return null;
    return (React.createElement(React.Fragment, null, articles.map((article, index) => (React.createElement(ArticleFragmentContext.Provider, { key: article.id, value: article }, returnLoopChild(children, {
        article,
        index,
    }))))));
};
Loop.displayName = 'Articles.Loop';
//# sourceMappingURL=articlesGroup.js.map